import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ReactGA from 'react-ga';

import Preloader from "./componets/preloader/Index";
import { FloatingButtons } from "./componets/element-design/floating-button";

const Index1 = lazy(() => import('./pages/home/index'));
const AboutPage = lazy(() => import('./pages/about'));
const ContactPage = lazy(() => import('./pages/contact'));
const ServicesPage = lazy(() => import('./pages/service'));
const NoMatch = lazy(() => import('./pages/errors/no-match'));

const ReadLey = lazy(() => import('./pages/read-ley'));
const YourSecurity = lazy(() => import('./pages/your-security'));
const UseRecomendations = lazy(() => import('./pages/use-recomendation'));
const BlockPages = lazy(() => import('./pages/blok-pages'));
const ParentalControl = lazy(() => import('./pages/parental-control'));
const PaymentPage = lazy(() => import('./pages/payment').then(m => ({ default: m.PaymentPage })));
const SpeedTestPage = lazy(() => import('./pages/speed-test').then(m => ({ default: m.SpeedTestPage })));
const PQRPage = lazy(() => import('./pages/pqr').then(m => ({ default: m.PQRPage })));
const PolicyDataPage = lazy(() => import('./pages/policy-data'));
const RegulationsPage = lazy(() => import('./pages/regulations'));
const NetworkSecurityPage = lazy(() => import('./pages/network-security'));
const UserRightsPage = lazy(() => import('./pages/user-rights'));
const ServiceContractPage = lazy(() => import('./pages/service-contract'));
const CommercialOffersPage = lazy(() => import('./pages/commercial-offers'));
const QualityIndicatorsPage = lazy(() => import('./pages/quality-indicators'));
const CookiesPolicyPage = lazy(() => import('./pages/cookies-policy'));
const EquipmentComodatoPage = lazy(() => import('./pages/equipment-comodato'));
const TRACKING_ID = "G-D4J8FVS7VR"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const App  =  () => {
	const [isFirstLoad, setIsFirstLoad] = React.useState(true);

	useEffect(() => {
		// Prevenir que el navegador intente restaurar el scroll de una sesión anterior
		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}
		window.scrollTo(0, 0);

		ReactGA.pageview(window.location.pathname + window.location.search);
		setIsFirstLoad(false);
	}, []);

	return (
			<BrowserRouter basename={'/'} >
				<Suspense fallback={isFirstLoad ? <Preloader /> : <div style={{minHeight: '60vh'}}></div>}>
				<Switch>
			
				  <Route exact path="/" component={Index1}/>
				  <Route path="index" component={Index1}/>

				  <Route path="/nuestra-empresa" component={AboutPage}/>
				  <Route path="/about" component={AboutPage}/>
				  <Route path="/servicios" component={ServicesPage}/>
				  <Route path="/services" component={ServicesPage}/>

				  <Route path="/contacto" component={ContactPage}/>
				  <Route path="/contact" component={ContactPage}/>

				  {/*MY ROUTERS*/}
				  <Route path="/ley-679" component={ReadLey}/>
				  <Route path="/su-seguridad" component={YourSecurity}/>
				  <Route path="/recomendaciones-de-uso" component={UseRecomendations}/>
				  <Route path="/bloqueo-de-paginas" component={BlockPages} />
				  <Route path="/internet-sano" component={BlockPages} />
				  <Route path="/control-parental" component={ParentalControl} />
				  <Route path="/paga-tu-factura" component={PaymentPage} />
				  <Route path="/test-velocidad" component={SpeedTestPage}/>
				  <Route path="/pqr" component={PQRPage}/>
				  <Route path="/pqrsf" component={PQRPage}/>
				  <Route path="/politica-proteccion-datos" component={PolicyDataPage}/>
				  <Route path="/normativa" component={RegulationsPage}/>
				  <Route path="/politica-seguridad-red" component={NetworkSecurityPage}/>
				  <Route path="/regimen-proteccion-usuario" component={UserRightsPage}/>
				  <Route path="/contrato-prestacion-servicios" component={ServiceContractPage}/>
				  <Route path="/ofertas-comerciales" component={CommercialOffersPage}/>
				  <Route path="/indicadores-calidad" component={QualityIndicatorsPage}/>
				  <Route path="/politica-cookies" component={CookiesPolicyPage}/>
				  <Route path="/equipos-comodato" component={EquipmentComodatoPage}/>

				  <Route component={NoMatch} />
				 
				</Switch>
				</Suspense>
				<ToastContainer />
				<FloatingButtons/>
			</BrowserRouter>
	);
}
 
export default App;
